<template>
  <div class="menu">
    <div class="container">
      <div class="title-wrap">
        <div class="title">{{this.data.coverTitle}}</div>
      </div>

      <div class="contain">
        <div class="block clickStyle" v-for="(item ,i) in menu" :key="i">
          <div class="sub-menu" :id="setSubMenuClass(i)" @mouseover="changeMenuIndex(i)">
            <div class="wrap">
              <div class="icon">
                <div v-if="menuIndex==i">
                  <img alt="xxx" :src="csvw_url + item.iconSelect" />
                </div>
                <div v-if="menuIndex!=i">
                  <img alt="xxx" :src="csvw_url + item.iconUrl" />
                </div>
              </div>
              <div class="middle text" :id="setSubMenuId(i)">{{item.text}}</div>
              <div class="arrow">
                <div v-if="menuIndex==i&&menuFlag">
                  <img alt="xxx" src="../../../assets/imgs/up-white.png" />
                </div>
                <div v-if="menuIndex==i&&!menuFlag">
                  <img alt="xxx" src="../../../assets/imgs/down-white.png" />
                </div>
                <div v-if="menuIndex!=i">
                  <img alt="xxx" src="../../../assets/imgs/down-black.png" />
                </div>
              </div>
              <div style="clear: both;"></div>
            </div>
          </div>
          <template v-if="menuIndex==i">
            <div :id="setSubItemWrapClass(i)" class="sub-item-wrap">
              <div
                class="sub-item"
                :id="setSubItemClass(i,j)"
                @click="changeItemIndex(i,j)"
                v-for="(sub,j) in item.subItem"
                :key="j"
              >
                <div class="wrap">
                  <div class="middle text" :id="setSubItemId(i,j)">{{sub.text}}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBrowserWidth } from "../../../components/js/screen";
import { csvw_url } from "../../../components/config";
export default {
  props: ["data", "changeItem"],
  name: "Menu",
  components: {},
  data() {
    return {
      csvw_url:csvw_url,
      menuIndex: 0, // 一级菜单
      itemIndex: 0, // 二级菜单
      menu: this.data.menu,
      menuFlag: true, //点击一级菜单是否打开
      menuFlagIndex: 10, //点击一级菜单的index
    };
  },
  mounted: function () {
    this.changeMenuIndex(0);
    this.changeItemIndex(0, 0);
  },
  updated: function () {},
  methods: {
    changeMenuIndex(i) {
      if (this.menuIndex == i) {
        if (this.menuFlagIndex == this.menuIndex) {
          // 两次点击
          // this.menuFlag = false;
          // this.menuFlagIndex = 10;
          // this.closeSubItem();
        } else {
          this.menuFlagIndex = this.menuIndex;
          this.menuFlag = true;
          this.openSubItem();
        }
      } else {
        this.menuFlagIndex = i;
        this.menuFlag = true;
      }

      this.menuIndex = i;

      this.clearMenu();
      document.getElementById(`sub-menu${i}`).style.background =
        "rgba(1, 1, 1, 0.7)";
      document.getElementById(`sub-menu-text${i}`).style.color =
        "rgba(255,255,255, 1)";
    },
    closeSubItem() {
      document.getElementById(`sub-item-wrap${this.menuIndex}`).style.height =
        "0px";
    },
    openSubItem() {
      let w = getBrowserWidth();
      let wid = 90;
      if (w <= 1300) {
        wid = 35;
      } else if (w > 1300 && w <= 1600) {
        wid = 42;
      } else if (w > 1600) {
        wid = 50;
      }
      document.getElementById(`sub-item-wrap${this.menuIndex}`).style.height =
        "";
    },
    changeItemIndex(i, j) {
      this.itemIndex = j;
      this.clearItem();
      document.getElementById(`sub-item${i}${j}`).style.background =
        "rgba(1, 1, 1, 0.3)";
      document.getElementById(`sub-item-text${i}${j}`).style.color =
        "rgba(255,255,255, 1)";
      this.changeItem(i, j);
    },
    clearMenu() {
      for (let index in this.menu) {
        if (this.menuIndex != index) {
          document.getElementById(`sub-menu${index}`).style.background = "";
          document.getElementById(`sub-menu-text${index}`).style.color =
            "rgba(0,0,0,1)";
        }
      }
    },
    clearItem() {
      for (let index in this.menu) {
        let item = this.menu[index];
        let subItem = item.subItem;
        for (let subIndex in subItem) {
          if (this.menuIndex == index && this.itemIndex != subIndex) {
            document.getElementById(
              `sub-item${index}${subIndex}`
            ).style.background = "";
            document.getElementById(
              `sub-item-text${index}${subIndex}`
            ).style.color = "rgba(1, 1, 1, 1)";
          }
        }
      }
    },
    setSubMenuClass(i) {
      let obj = `sub-menu${i}`;
      return obj;
    },
    setSubMenuId(i) {
      let obj = `sub-menu-text${i}`;
      return obj;
    },
    setSubItemClass(i, j) {
      let obj = `sub-item${i}${j}`;
      return obj;
    },
    setSubItemWrapClass(i) {
      let obj = `sub-item-wrap${i}`;
      return obj;
    },
    setSubItemId(i, j) {
      let obj = `sub-item-text${i}${j}`;
      return obj;
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: myCu;
  src: url("../../../assets/font/FZYouHJW_Cu.TTF"),
    url("../../../assets/font/FZYouHJW_Cu.eot");
  /* IE9+,可以是具体的实际链接 */
}

.clickStyle {
  cursor: pointer;
}

@media screen and (min-width: 1px) {
  .text-select {
    font-size: 18px;
    color: rgba(255, 255, 255, 1);
  }
  .text {
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
  }
  .menu {
    transition: width 0.28s;
    width: 450px !important;
    background: rgba(255, 255, 255, 0.7);
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow: hidden;
  }
  .container {
    position: relative;
  }
  .title-wrap {
    position: relative;
    width: 100%;
    height: 110px;
    border-bottom: 1px solid rgba(207, 207, 207, 1);
  }
  .title {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    height: 50px;
    font-size: 30px;
    line-height: 32px;
    color: rgba(0, 0, 0, 1);
    font-weight: bold;
    margin-left: 50px;
  }
  .contain {
    width: 100%;
    margin-top: 45px;
  }
  .sub-menu {
    position: relative;
    width: 100%;
    height: 50px;
  }
  .sub-menu .wrap {
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 320px;
    height: 30px;
  }
  .sub-menu .icon {
    position: relative;
    float: left;
    width: 23px;
    height: 100%;
  }
  .sub-menu .icon img {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    height: 19px;
  }
  .sub-menu .middle {
    position: relative;
    float: left;
    margin-left: 28px;
    line-height: 30px;
    font-weight: bold;
  }
  .sub-menu .arrow {
    position: relative;
    float: right;
    width: 13px;
    height: 100%;
  }
  .sub-menu .arrow img {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    height: 10px;
  }

  .sub-item-wrap {
    overflow: hidden;
  }
  .sub-item {
    position: relative;
    width: 100%;
    height: 50px;
  }
  .sub-item .wrap {
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 300px;
    height: 30px;
  }
  .sub-item .wrap .middle {
    margin-left: 41px;
    line-height: 30px;
  }
}

@media screen and (min-width: 1px) and (max-width: 1300px) {
  .text {
    font-size: 12px;
    color: rgba(0, 0, 0, 1);
  }
  .menu {
    transition: width 0.28s;
    width: 305px !important;
    background: rgba(255, 255, 255, 0.7);
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow: hidden;
  }
  .container {
    position: relative;
  }
  .title-wrap {
    position: relative;
    width: 100%;
    height: 70px;
    border-bottom: 1px solid rgba(207, 207, 207, 1);
  }
  .title {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    height: 22px;
    font-size: 20px;
    line-height: 22px;
    color: rgba(0, 0, 0, 1);
    font-weight: bold;
    margin-left: 35px;
  }
  .contain {
    width: 100%;
    margin-top: 30px;
  }
  .sub-menu {
    position: relative;
    width: 100%;
    height: 35px;
  }
  .sub-menu .wrap {
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 210px;
    height: 25px;
  }
  .sub-menu .icon {
    position: relative;
    float: left;
    width: 23px;
    height: 100%;
  }
  .sub-menu .icon img {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    height: 13px;
  }
  .sub-menu .middle {
    position: relative;
    float: left;
    margin-left: 10px;
    line-height: 25px;
    font-weight: bold;
  }
  .sub-menu .arrow {
    position: relative;
    float: right;
    width: 9px;
    height: 100%;
  }
  .sub-menu .arrow img {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    height: 7px;
  }

  .sub-item {
    position: relative;
    width: 100%;
    height: 35px;
  }
  .sub-item .wrap {
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 300px;
    height: 25px;
  }
  .sub-item .wrap .middle {
    margin-left: 78px;
    line-height: 25px;
  }
}

@media screen and (min-width: 1301px) and (max-width: 1600px) {
  .text {
    font-size: 15px;
    color: rgba(0, 0, 0, 1);
  }
  .menu {
    transition: width 0.28s;
    width: 375px !important;
    background: rgba(255, 255, 255, 0.7);
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow: hidden;
  }
  .container {
    position: relative;
  }
  .title-wrap {
    position: relative;
    width: 100%;
    height: 90px;
    border-bottom: 1px solid rgba(207, 207, 207, 1);
  }
  .title {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    height: 27px;
    font-size: 25px;
    line-height: 27px;
    color: rgba(0, 0, 0, 1);
    font-weight: bold;
    margin-left: 42px;
  }
  .contain {
    width: 100%;
    margin-top: 38px;
  }
  .sub-menu {
    position: relative;
    width: 100%;
    height: 42px;
  }
  .sub-menu .wrap {
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 250px;
    height: 30px;
  }
  .sub-menu .icon {
    position: relative;
    float: left;
    width: 23px;
    height: 100%;
  }
  .sub-menu .icon img {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    height: 15px;
  }
  .sub-menu .middle {
    position: relative;
    float: left;
    margin-left: 10px;
    line-height: 30px;
    font-weight: bold;
  }
  .sub-menu .arrow {
    position: relative;
    float: right;
    width: 9px;
    height: 100%;
  }
  .sub-menu .arrow img {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    height: 7px;
  }

  .sub-item {
    position: relative;
    width: 100%;
    height: 42px;
  }
  .sub-item .wrap {
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 300px;
    height: 30px;
  }
  .sub-item .wrap .middle {
    margin-left: 59px;
    line-height: 30px;
  }
}
</style>